function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.028.908a1.5 1.5 0 00-2.12.064l-8.47 9a1.5 1.5 0 000 2.056l8.47 9a1.5 1.5 0 102.184-2.056L3.59 11l7.503-7.972a1.5 1.5 0 00-.064-2.12z"
});

var SvgArrowLeft = function SvgArrowLeft(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 12 22",
    fill: "currentColor"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTIgMjIiIGZpbGw9ImN1cnJlbnRDb2xvciIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggIGQ9Ik0xMS4wMjggMC45MDc3MDRDMTAuNDI0OCAwLjMzOTkzIDkuNDc1NDcgMC4zNjg2OTcgOC45MDc3IDAuOTcxOTU3TDAuNDM3MTA2IDkuOTcxOTZDLTAuMTA2NDk0IDEwLjU0OTUgLTAuMTA2NDk0IDExLjQ1MDUgMC40MzcxMDYgMTIuMDI4MUw4LjkwNzcgMjEuMDI4QzkuNDc1NDcgMjEuNjMxMyAxMC40MjQ4IDIxLjY2MDEgMTEuMDI4IDIxLjA5MjNDMTEuNjMxMyAyMC41MjQ1IDExLjY2MDEgMTkuNTc1MiAxMS4wOTIzIDE4Ljk3MkwzLjU4OTI4IDExTDExLjA5MjMgMy4wMjgwNUMxMS42NjAxIDIuNDI0NzkgMTEuNjMxMyAxLjQ3NTQ4IDExLjAyOCAwLjkwNzcwNFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgArrowLeft as ReactComponent };